<template>
<div class="chapter">
<div class="inner_page">
<p class="textcenter1"><a id="ch00_fm03_also"></a><a id="page_vi"></a><strong>Also by Dagoberto Gilb</strong></p>
<p class="textcenter"><em>The Magic of Blood<br/>The Last Known Residence of Mickey Acuña</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03_also.vue?5bea6d44